import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useUrlParam = (name: string) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlParam = searchParams.get(name);

  const setParam = useCallback(
    (value: string) => {
      if (!value) return;
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set(name, value);
          return next;
        },
        { replace: true },
      );
    },
    [name, setSearchParams],
  );

  const removeParam = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(name);
        return next;
      },
      { replace: true },
    );
  }, [name, setSearchParams]);

  return { urlParam, setParam, removeParam };
};
